var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6519 1.76691C12.2029 1.96645 11.729 2.09116 11.2302 2.16598C11.729 1.86668 12.1281 1.39279 12.3027 0.819124C11.8288 1.09348 11.305 1.29302 10.7314 1.41773C10.2824 0.943833 9.63392 0.644531 8.93554 0.644531C7.58869 0.644531 6.49125 1.74197 6.49125 3.08883C6.49125 3.28836 6.51619 3.46295 6.56607 3.63755C4.54579 3.53778 2.72504 2.56505 1.50289 1.06854C1.30335 1.44267 1.17865 1.84174 1.17865 2.29069C1.17865 3.13871 1.60266 3.88697 2.27608 4.33592C1.87702 4.31098 1.50289 4.21121 1.1537 4.03662V4.06156C1.1537 5.25876 2.00173 6.25644 3.12411 6.48091C2.92457 6.5308 2.7001 6.55574 2.47562 6.55574C2.32597 6.55574 2.15138 6.5308 2.00173 6.50585C2.32597 7.47859 3.22387 8.2019 4.29637 8.2019C3.44835 8.85038 2.40079 9.24945 1.25347 9.24945C1.05394 9.24945 0.854402 9.24945 0.67981 9.22451C1.77725 9.92288 3.04928 10.322 4.44602 10.322C8.96049 10.322 11.4297 6.58068 11.4297 3.33825C11.4297 3.23848 11.4297 3.11377 11.4297 3.014C11.9036 2.68976 12.3276 2.26575 12.6519 1.76691Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.7831456d8f65422b98d1529581c32cb3.svg";
export { ForwardRef as ReactComponent };